import React, { useEffect, useState } from "react";
import "./HeroSection.scss";

import nhsLogo from "../../assets/Images/TrustedPartner/nhs.png";
import cernLogo from "../../assets/Images/TrustedPartner/cern.png";
import channel4Logo from "../../assets/Images/TrustedPartner/channel4.png";
import arupLogo from "../../assets/Images/TrustedPartner/arup.png";

const ArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 8h10M9 4l4 4-4 4" />
  </svg>
);

const HeroSection = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 150);
    return () => clearTimeout(t);
  }, []);

  const v = loaded ? " is-visible" : "";

  const stats = [
    {
      label: "Engagement Model",
      value: "Fixed",
      desc: "Scope, deliverable and cost defined before you commit",
    },
    {
      label: "Time to First Outcome",
      value: "Weeks",
      desc: "Not months. Not quarters. Compressed advisory cycles.",
    },
    {
      label: "Team Model",
      value: "Senior-led",
      desc: "Every engagement is led by senior architects and consultants",
    },
    {
      label: "Strategy Call",
      value: "30 min",
      desc: "A defined, decision-ready next step. No obligation.",
    },
  ];

  return (
    <section className="hero">
      {/* Background animation */}
      <div className="hero__bg-grid" aria-hidden="true" />
      <div className="hero__bg-orb hero__bg-orb--1" aria-hidden="true" />
      <div className="hero__bg-orb hero__bg-orb--2" aria-hidden="true" />
      <div className="hero__bg-orb hero__bg-orb--3" aria-hidden="true" />

      <div className="hero__layout">
        <div className="hero__inner">
          <div className={`hero__badge${v}`}>
            <span className="hero__badge-dot" />
            Consult &bull; Audit &bull; Build &bull; Scale
          </div>

          <h1 className={`hero__title${v}`}>
            <span className="hero__title-small">Big 4-Grade Advisory.</span>
            <em className="hero__title-italic">AI-Native Engineering.</em>
          </h1>

          <p className={`hero__desc${v}`}>
            digiRyte helps organisations define technology strategy, assess risk
            and readiness, and build scalable AI-powered platforms - through
            senior-led engagements designed to move from uncertainty to
            execution without the handover gap.
          </p>

          <div className={`hero__actions${v}`}>
            <a href="/contact-us" className="hero__btn-primary">
              Book a Strategy Call <ArrowIcon />
            </a>
            <a href="/services" className="hero__btn-outline">
              View Engagements <ArrowIcon />
            </a>
          </div>
        </div>

        {/* Right stats panel */}
        <div className={`hero__stats-panel${v}`}>
          {stats.map((s, i) => (
            <div className="hero__stat" key={i}>
              <span className="hero__stat-label">{s.label}</span>
              <span className="hero__stat-value">{s.value}</span>
              <span className="hero__stat-desc">{s.desc}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Trust strip */}
      <div className="hero__trust-wrap">
        <div className={`hero__trust${v}`}>
          <span className="hero__trust-label">Trusted by</span>
          <div className="hero__trust-logos">
            <img src={nhsLogo} alt="NHS" className="hero__trust-logo" />
            <img src={cernLogo} alt="CERN" className="hero__trust-logo" />
            <img
              src={channel4Logo}
              alt="Channel 4"
              className="hero__trust-logo"
            />
            <img src={arupLogo} alt="ARUP" className="hero__trust-logo" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
